module.exports = __webpack_public_path__ + "img/carousel-arrow-right.83ab80b1.svg";